import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import SideBar from "../common/sideBar";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import Pagination from "../common/Pagination";
import NoData from "../common/NoData";
import useModel from "../common/useModel";
import Model from "./editdsaconf";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
const DSAConfiguration = (props) => {
  //Set initial state
  const [rodp, handleRodp] = useState([]);
  const { isShowing, toggle } = useModel(false);
  const [rates, handleRates] = useState([]);
  const [oldrates, handleOldRates] = useState([]);
  const [oldview, handleoldview] = useState(false);
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  useEffect(() => {
    getCityStateRate(0);
  }, []);

  //Update rate for city state
  const updateRate = async (params) => {
    try {
      const data = await Axios.put(endPoints.updateRates, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        toast.success("Changes successfully updated", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          toastId: "1",
        });
        toggle();
        getCityStateRate(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Fetching City state Rate
  const getCityStateRate = async (skip, station) => {
    try {
      const data = await Axios.get(endPoints.getdsaconfig);
      const result = data.data.data;
      handleRodp(result);
    } catch (error) {
      console.log(error);
      handleRodp([]);
    }
  };

  const openPopup = (rates) => {
    
    handleRates(rates);
    toggle();
  };

  //Return the table for city state
  return (
    <div className="dashboardContainer">
      
      <HeaderAdminpanel />
      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar />
        </section>
        <section
          id="dashboard-rightContainer"
          className="dashboard-manageSales"
        >
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Trade Partner Management |
              <span className="breadcrumb-active fct-breadcrumb">
                Trade Partner Configuration
              </span>
            </div>
            <div class="search_camp">
              <button
                onClick={(e) => {
                  openPopup(rodp[0]);
                }}
                class="search_camp_btn"
              >
                Edit
              </button>
              {rodp &&
                rodp[0] &&
                rodp[0].history &&
                rodp[0].history.length > 1 && (
                  <select
                    class="packageType drop-down-icon"
                    style={{ marginLeft: "15px" }}
                    onChange={(e) => {
                      handleoldview(true);
                      handleOldRates(rodp[0].history[e.target.value]);
                    }}
                  >
                    <option> Refer Previous Versions</option>
                    {rodp[0].history.map((e, index) => {
                      return <option value={index}> V- 00{index + 1} </option>;
                    })}
                  </select>
                )}
            </div>
          </div>
          <div
            className={
              rodp.length === 0
                ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                : "dashboard-content userListing-dashboard bg-white table-responsive"
            }
          >
            <table className="table table-striped master-table">
              <tbody>
                {!oldview &&
                  rodp.map((r) => (
                    <React.Fragment>
                      <tr>
                        <td>
                          <label>First order incentive (%)</label>
                        </td>

                        <td>{r.firstorder}</td>
                      </tr>
                      <tr>
                        <td>
                          Repeat order in same calendar month incentive (%)
                        </td>
                        <td>{r.repeatordersamemonth}</td>
                      </tr>
                      <tr>
                        <td>Repeat order incentive in subsequent months(%)</td>
                        <td>{r.repeatordersubsmonth}</td>
                      </tr>
                      <tr>
                        <td>Incentive for low volume(%)</td>
                        <td>{r.lowvolume}</td>
                      </tr>
                      <tr>
                        <td>Incentive for higher volume(%)</td>
                        <td>{r.highvolume}</td>
                      </tr>
                      <tr>
                        <td>No of minimum orders per month</td>
                        <td>{r.minOrder}</td>
                      </tr>
                      <tr>
                        <td>No of maximum orders per month</td>
                        <td>{r.maxOrder}</td>
                      </tr>
                      <tr>
                        <td>
                          Minimum order value per month( x times of minimum
                          value of Trade Partner base station)
                        </td>
                        <td>{r.minOrderValue}</td>
                      </tr>
                      <tr>
                        <td>
                          Maximum order value per month( x times of minimum
                          value of Trade Partner base station)
                        </td>
                        <td>{r.maxOrderValue}</td>
                      </tr>
                      <tr>
                        <td>Base State for GST</td>
                        <td>{r.baseState}</td>
                      </tr>
                      <tr>
                        <td>Post Address</td>
                        <td>{r.baseAddress}</td>
                      </tr>
                      <tr>
                        <td>IGST (%)</td>
                        <td>{r.igst}</td>
                      </tr>
                      <tr>
                        <td>CGST (%)</td>
                        <td>{r.cgst}</td>
                      </tr>
                      <tr>
                        <td>SGST (%)</td>
                        <td>{r.sgst}</td>
                      </tr>

                      <tr>
                        <td>Enforce minimum value</td>
                        <td>{r.EnforceminValue}</td>
                      </tr>

                      <tr>
                        <td>Enable/Disable Incentive Calculation Timeperiod</td>
                        <td>{r.incentiveCalculationTimeperiodEnabled}</td>
                      </tr>

                      { (r.incentiveCalculationTimeperiodEnabled == 'true' || r.incentiveCalculationTimeperiodEnabled == true) && (
                        <tr>
                          <td>Incentive Calculation Maximum Timeperiod (months)</td>
                          <td>{r.incentiveCalculationMaxTimeperiod}</td>
                        </tr>
                      ) }
                      
                    </React.Fragment>
                  ))}
                {oldview && (
                  <React.Fragment>
                    <tr>
                      <td>
                        <label>Changed By</label>
                      </td>
                      <td>{oldrates.changedBy}</td>
                    </tr>
                    <tr>
                      <td>
                        <label>Start Date</label>
                      </td>

                      <td>{moment(oldrates.startdate).format('DD MMM YYYY HH:mm:ss')}</td>
                    </tr>
                    <tr>
                      <td>
                        <label>End Date</label>
                      </td>
                      <td>{moment(oldrates.enddate).format('DD MMM YYYY HH:mm:ss')}</td>
                    </tr>
                    <tr>
                      <td>
                        <label>First order incentive (%)</label>
                      </td>

                      <td>{oldrates.firstorder}</td>
                    </tr>
                    <tr>
                      <td>Repeat order in same calendar month incentive (%)</td>
                      <td>{oldrates.repeatordersamemonth}</td>
                    </tr>
                    <tr>
                      <td>Repeat order incentive in subsequent months(%)</td>
                      <td>{oldrates.repeatordersubsmonth}</td>
                    </tr>
                    <tr>
                      <td>Incentive for low volume(%)</td>
                      <td>{oldrates.lowvolume}</td>
                    </tr>
                    <tr>
                      <td>Incentive for higher volume(%)</td>
                      <td>{oldrates.highvolume}</td>
                    </tr>
                    <tr>
                      <td>No of minimum orders per month</td>
                      <td>{oldrates.minOrder}</td>
                    </tr>
                    <tr>
                      <td>No of maximum orders per month</td>
                      <td>{oldrates.maxOrder}</td>
                    </tr>
                    <tr>
                      <td>
                        Minimum order value per month( x times of minimum value
                        of Trade Partner base station)
                      </td>
                      <td>{oldrates.minOrderValue}</td>
                    </tr>
                    <tr>
                      <td>
                        Maximum order value per month( x times of minimum value
                        of Trade Partner base station)
                      </td>
                      <td>{oldrates.maxOrderValue}</td>
                    </tr>
                    <tr>
                        <td>Base State for GST</td>
                        <td>{oldrates.baseState}</td>
                      </tr>
                      <tr>
                        <td>Post Address</td>
                        <td>{oldrates.baseAddress}</td>
                      </tr>
                      <tr>
                        <td>IGST (%)</td>
                        <td>{oldrates.igst}</td>
                      </tr>
                      <tr>
                        <td>CGST (%)</td>
                        <td>{oldrates.cgst}</td>
                      </tr>
                      <tr>
                        <td>SGST (%)</td>
                        <td>{oldrates.sgst}</td>
                      </tr>
                      <tr>
                        <td>Enforce minimum value</td>
                        <td>{oldrates.EnforceminValue}</td>
                      </tr>
                      <tr>
                        <td>Enable/Disable Incentive Calculation Timeperiod</td>
                        <td>{oldrates.incentiveCalculationTimeperiodEnabled}</td>
                      </tr>
                      { (oldrates.incentiveCalculationTimeperiodEnabled == 'true' || oldrates.incentiveCalculationTimeperiodEnabled == true) && (
                        <tr>
                          <td>Incentive Calculation Maximum Timeperiod (months)</td>
                          <td>{oldrates.incentiveCalculationMaxTimeperiod}</td>
                        </tr>
                      ) }
                  </React.Fragment>
                )}
              </tbody>
            </table>
          </div>
          {rodp.length === 0 ? <NoData /> : null}
          <Model
        isShowing={isShowing}
        hide={toggle}
        rates={rates}
        updateRate={updateRate}
      />
        </section>
      </div>
      <ToastContainer />
    </div>
  );
};

export default connect(null, {})(DSAConfiguration);



// WEBPACK FOOTER //
// ./web/components/admin/dsa_management/dsaconfigration.jsx